module.exports = __webpack_public_path__ + "img/TradingCentral.dd95ef65.svg";